// import {
//   Alert,
//   Badge,
//   Box,
//   Button,
//   CircularProgress,
//   Container,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   FormControl,
//   Grid,
//   InputLabel,
//   MenuItem,
//   Paper,
//   Select,
//   Snackbar,
//   Tab,
//   Tabs,
//   TextField,
//   Tooltip,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { useAppSelector } from 'app/hooks';
// import React, { useEffect, useState } from 'react';
// import {
//   FaArrowDown,
//   FaArrowUp,
//   FaBalanceScale,
//   FaCalendarCheck,
//   FaCheckDouble,
//   FaClock,
//   FaCoins,
//   FaDollarSign,
//   FaExclamationTriangle,
//   FaSearch,
//   FaShoppingCart,
//   FaTimesCircle
// } from 'react-icons/fa';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router';

// import {
//   acceptRejectSellAssetRequest,
//   AcceptRejectSellAssetRequestPayload,
//   clearCurrentBuySellCertificateData
// } from 'slices/fundManagementInvestment/simulationDashboardSlice';
// import CertificateViewer from '../certificate/CertificateViewer';

// // Import Redux actions and selectors
// import {
//   acceptRejectAssetRequest,
//   acceptRejectRevaluationRequest,
//   acceptRejectUnitsRequest,
//   clearError,
//   getContributionRequests,
//   getLandingData,
//   getPurchaseAssetRequests,
//   getPurchaseUnitsRequests,
//   getRevaluationAssetRequests,
//   getSellUnitsRequests,
//   resetAssetAcceptRejectStatus,
//   resetRevaluationAcceptRejectStatus,
//   resetUnitsAcceptRejectStatus,
//   selectAssetAcceptRejectStatus,
//   selectAssetRequests,
//   selectContributionRequests,
//   selectContributionRequestsStatus,
//   selectError,
//   selectLoading,
//   selectPurchaseRequests,
//   selectRevaluationAcceptRejectStatus,
//   selectRevaluationRequests,
//   selectRevaluationRequestsStatus,
//   selectUnitsAcceptRejectStatus,
//   type AcceptRejectAssetPayload,
//   type AcceptRejectRevaluationPayload,
//   type AcceptRejectUnitsPayload,
//   type GetSellRequestsPayload
// } from '../../../slices/fundManagementInvestment/fundmanagementInvestmentSlice';

// // ✅ Import from simulation slice
// import {
//   acceptRejectContributionRequest,
//   acceptRejectSellUnitsRequest,
//   clearAcceptRejectResponse,
//   clearAcceptRejectSellUnitsResponse,
//   getSellAssetRequests,
//   type AcceptRejectRequestPayload,
//   type AcceptRejectSellUnitsPayload,
//   type GetSellAssetRequestsPayload,
//   type SellAssetRequestItem
// } from 'slices/fundManagementInvestment/simulationDashboardSlice';

// // Import local components and utilities
// import { useDrawer } from 'components/app/DrawerContext';
// import RequestCard from './RequestCard';
// import RequestDialog from './RequestDialog';
// import {
//   AssetRequest,
//   ContributionRequest,
//   GetAssetRequestsPayload,
//   GetContributionRequestsPayload,
//   GetPurchaseRequestsPayload,
//   GetRevaluationRequestsPayload,
//   LocationState,
//   PurchaseRequest,
//   RevaluationRequest,
//   SellRequest,
//   SnackbarState,
//   TabConfig
// } from './types';
// import { filterRequests, formatCurrency, getInvestorEmail, isAdminLogin } from './utils';

// // Type guard for SellAssetRequestItem
// const isSellAssetRequest = (req: any): req is SellAssetRequestItem => {
//   return req && 'assetSellId' in req && 'assetId' in req;
// };

// // Helper to get requestId from any request type
// const getRequestId = (request: any): string => {
//   if ('requestId' in request) {
//     return request.requestId;
//   }
//   if ('assetSellId' in request) {
//     return request.assetSellId;
//   }
//   return '';
// };

// const ApprovalRequest: React.FC = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const location = useLocation();
//   const locationState = (location.state as LocationState) || undefined;

//   console.log('Location State:', locationState);

//   // ✅ Support both 'to' and 'unitType' parameters
//   const { from, to, unitType, isAdmin: locationIsAdmin } = locationState || {};

//   // Use whichever is provided (to takes priority)
//   const routeUnitType = to || unitType;

//   // Use drawer context for admin state management
//   const { fundManagementAdminRight, setFundManagementAdminRight } = useDrawer();

//   // Certificate modal state - ADD THIS
//   const [showCertificateModal, setShowCertificateModal] = useState(false);
//   const [certificatePayload, setCertificatePayload] = useState<any>(null);

//   // Calculate admin status and update context
//   useEffect(() => {
//     const calculatedIsAdmin = isAdminLogin({ isAdmin: locationIsAdmin });
//     setFundManagementAdminRight(calculatedIsAdmin);
//   }, [locationIsAdmin, setFundManagementAdminRight]);

//   const isAdmin = locationIsAdmin || fundManagementAdminRight;
//   const dispatch = useDispatch();

//   // Redux selectors
//   const purchaseRequests = useSelector(selectPurchaseRequests) as PurchaseRequest[];
//   const assetRequests = useSelector(selectAssetRequests) as AssetRequest[];
//   const revaluationRequests = useSelector(selectRevaluationRequests) as RevaluationRequest[];
//   const contributionRequests = useSelector(selectContributionRequests) as ContributionRequest[];
//   const sellRequests = useSelector(
//     (state: any) => state.fundManagementInvestment.sellRequests
//   ) as SellRequest[];
//   const loading = useSelector(selectLoading);
//   const error = useSelector(selectError);
//   const unitsAcceptRejectStatus = useSelector(selectUnitsAcceptRejectStatus);
//   const assetAcceptRejectStatus = useSelector(selectAssetAcceptRejectStatus);
//   const revaluationRequestsStatus = useSelector(selectRevaluationRequestsStatus);
//   const revaluationAcceptRejectStatus = useSelector(selectRevaluationAcceptRejectStatus);
//   const contributionRequestsStatus = useSelector(selectContributionRequestsStatus);

//   // ✅ Get asset sell requests from simulation slice
//   const sellAssetRequestsLoading = useAppSelector(
//     (state) => state.simulationDashboard?.sellAssetRequestsLoading || false
//   );
//   const sellAssetRequestsError = useAppSelector(
//     (state) => state.simulationDashboard?.sellAssetRequestsError || null
//   );
//   const sellAssetRequestsData = useAppSelector(
//     (state) => state.simulationDashboard?.sellAssetRequestsData || null
//   );
//   const acceptRejectSellAssetResponse = useAppSelector(
//     (state) => state.simulationDashboard.acceptRejectSellAssetResponse
//   );

//   // Get unified contribution accept/reject state from simulation slice
//   const contributionAcceptRejectLoading = useAppSelector(
//     (state) => state.simulationDashboard?.acceptRejectLoading || false
//   );
//   const contributionAcceptRejectError = useAppSelector(
//     (state) => state.simulationDashboard?.acceptRejectError || null
//   );
//   const contributionAcceptRejectResponse = useAppSelector(
//     (state) => state.simulationDashboard?.acceptRejectResponse || null
//   );

//   // ✅ NEW: Get sell units accept/reject state from simulation slice
//   const acceptRejectSellUnitsLoading = useAppSelector(
//     (state) => state.simulationDashboard?.acceptRejectSellUnitsLoading || false
//   );
//   const acceptRejectSellUnitsError = useAppSelector(
//     (state) => state.simulationDashboard?.acceptRejectSellUnitsError || null
//   );
//   const acceptRejectSellUnitsResponse = useAppSelector(
//     (state) => state.simulationDashboard?.acceptRejectSellUnitsResponse || null
//   );

//   // Project and service info
//   const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
//   const selectedServiceTitle = useAppSelector((state) => {
//     return state.serviceSelected.selectedServiceTitle;
//   });

//   const investorEmail = getInvestorEmail();

//   // ✅ Tab configurations WITH NEW ASSET SELL REQUEST TABS
//   const allTabConfigs: TabConfig[] = [
//     {
//       key: 'incomeUnits',
//       label: 'Income Units',
//       icon: <FaCoins size={16} />,
//       description: 'Income unit subscription requests',
//       subscriptionType: 'incomeUnits',
//       isActive: true,
//       tabType: 'unitsSubscription'
//     },
//     {
//       key: 'growthUnits',
//       label: 'Growth Units',
//       icon: <FaArrowUp size={16} />,
//       description: 'Growth unit subscription requests',
//       subscriptionType: 'growthUnits',
//       isActive: true,
//       tabType: 'unitsSubscription'
//     },
//     {
//       key: 'assetPurchase',
//       label: 'Income Asset Purchase',
//       icon: <FaShoppingCart size={16} />,
//       description: 'Income asset purchase requests',
//       subscriptionType: 'incomeUnits',
//       isActive: true,
//       tabType: 'assetPurchase'
//     },
//     {
//       key: 'growthAssetPurchase',
//       label: 'Growth Asset Purchase',
//       icon: <FaShoppingCart size={16} />,
//       description: 'Growth asset purchase requests',
//       subscriptionType: 'growthUnits',
//       isActive: true,
//       tabType: 'assetPurchase'
//     },
//     {
//       key: 'incomeContribution',
//       label: 'Income Contribution',
//       icon: <FaCalendarCheck size={16} />,
//       description: 'Income contribution requests',
//       subscriptionType: 'incomeUnits',
//       isActive: true,
//       tabType: 'contributionRequest',
//       adminOnly: true
//     },
//     {
//       key: 'growthContribution',
//       label: 'Growth Contribution',
//       icon: <FaCalendarCheck size={16} />,
//       description: 'Growth contribution requests',
//       subscriptionType: 'growthUnits',
//       isActive: true,
//       tabType: 'contributionRequest',
//       adminOnly: true
//     },
//     {
//       key: 'incomeAssetRevaluation',
//       label: 'Income Asset Revaluation',
//       icon: <FaBalanceScale size={16} />,
//       description: 'Income asset revaluation requests',
//       subscriptionType: 'incomeUnits',
//       isActive: true,
//       tabType: 'assetRevaluation'
//     },
//     {
//       key: 'growthAssetRevaluation',
//       label: 'Growth Asset Revaluation',
//       icon: <FaBalanceScale size={16} />,
//       description: 'Growth asset revaluation requests',
//       subscriptionType: 'growthUnits',
//       isActive: true,
//       tabType: 'assetRevaluation'
//     },
//     {
//       key: 'incomeUnitSell',
//       label: 'Income Unit Sell',
//       icon: <FaArrowDown size={16} />,
//       description: 'Income unit sell requests',
//       subscriptionType: 'incomeUnits',
//       isActive: true,
//       tabType: 'unitSell'
//     },
//     {
//       key: 'growthUnitSell',
//       label: 'Growth Unit Sell',
//       icon: <FaArrowDown size={16} />,
//       description: 'Growth unit sell requests',
//       subscriptionType: 'growthUnits',
//       isActive: true,
//       tabType: 'unitSell'
//     },
//     // ✅ NEW: Income Asset Sell Request tab
//     {
//       key: 'incomeAssetSellReq',
//       label: 'Income Asset Sell',
//       icon: <FaArrowDown size={16} />,
//       description: 'Income asset sell requests',
//       subscriptionType: 'incomeUnits',
//       isActive: true,
//       tabType: 'assetSellRequest',
//       adminOnly: true
//     },
//     // ✅ NEW: Growth Asset Sell Request tab
//     {
//       key: 'growthAssetSellReq',
//       label: 'Growth Asset Sell',
//       icon: <FaArrowDown size={16} />,
//       description: 'Growth asset sell requests',
//       subscriptionType: 'growthUnits',
//       isActive: true,
//       tabType: 'assetSellRequest',
//       adminOnly: true
//     }
//   ];

//   // Filter tabs based on admin status
//   const tabConfigs = isAdmin
//     ? allTabConfigs
//     : allTabConfigs.filter(
//         (tab) =>
//           !tab.adminOnly &&
//           ['incomeUnits', 'growthUnits', 'incomeUnitSell', 'growthUnitSell'].includes(tab.key)
//       );

//   // ✅ UPDATED: getDefaultTabIndex with dual parameter support
//   const getDefaultTabIndex = (): number => {
//     let targetTabKey: string | null = null;

//     if (from === 'unitPurchase') {
//       targetTabKey = routeUnitType === 'growthUnits' ? 'growthUnits' : 'incomeUnits';
//     } else if (from === 'purchaseAssets') {
//       if (!isAdmin) return 0;
//       targetTabKey = routeUnitType === 'growthUnits' ? 'growthAssetPurchase' : 'assetPurchase';
//     } else if (from === 'assetSell') {
//       if (!isAdmin) return 0;
//       targetTabKey = routeUnitType === 'growthUnits' ? 'growthAssetSellReq' : 'incomeAssetSellReq';
//     } else if (from === 'unitSell') {
//       targetTabKey = routeUnitType === 'growthUnits' ? 'growthUnitSell' : 'incomeUnitSell';
//     }

//     // Find the index of the target tab
//     if (targetTabKey) {
//       const filteredIndex = tabConfigs.findIndex((tab) => tab.key === targetTabKey);
//       return filteredIndex !== -1 ? filteredIndex : 0;
//     }

//     return 0;
//   };

//   const [activeTab, setActiveTab] = useState(() => {
//     const defaultIndex = getDefaultTabIndex();
//     return defaultIndex < tabConfigs.length ? defaultIndex : 0;
//   });

//   const [selectedRequest, setSelectedRequest] = useState<
//     | PurchaseRequest
//     | AssetRequest
//     | RevaluationRequest
//     | ContributionRequest
//     | SellRequest
//     | SellAssetRequestItem
//     | null
//   >(null);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
//   const [actionType, setActionType] = useState<'accept' | 'reject'>('accept');
//   const [filterStatus, setFilterStatus] = useState<string>('all');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [snackbar, setSnackbar] = useState<SnackbarState>({
//     open: false,
//     message: '',
//     severity: 'success'
//   });

//   const [batchConfirmDialogOpen, setBatchConfirmDialogOpen] = useState(false);
//   const [batchActionType, setBatchActionType] = useState<'accept' | 'reject'>('accept');

//   useEffect(() => {
//     if (activeTab >= tabConfigs.length) {
//       setActiveTab(0);
//     }
//   }, [tabConfigs.length, activeTab]);


  


//   useEffect(() => {
//     if (selectedProjectId && tabConfigs.length > 0) {
//       const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
//       const defaultTab = tabConfigs[currentIndex];
//       if (defaultTab?.isActive) {
//         loadTabData(defaultTab);
//       }
//     }
//   }, [selectedProjectId, selectedServiceTitle, tabConfigs.length, location.pathname]);

//   useEffect(() => {
//     if (selectedProjectId && tabConfigs.length > 0) {
//       const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
//       const currentTabConfig = tabConfigs[currentIndex];
//       if (currentTabConfig?.isActive) {
//         loadTabData(currentTabConfig);
//       }
//     }
//   }, [activeTab, selectedProjectId]);

 

//   useEffect(() => {
//     const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
//     const currentTabConfig = tabConfigs[currentIndex];
//     const currentTabType = currentTabConfig?.tabType;

//     // ✅ FIXED: Changed 'loading' to 'pending' to match Redux Toolkit status
//     let acceptRejectStatus: 'idle' | 'pending' | 'succeeded' | 'failed' = 'idle';
//     let resetFunction: any = null;
//     let statusError: string | null = null;

//     if (currentTabType === 'unitsSubscription') {
//       acceptRejectStatus = unitsAcceptRejectStatus;
//       resetFunction = resetUnitsAcceptRejectStatus;
//       statusError = error;
//     } else if (currentTabType === 'assetPurchase') {
//       acceptRejectStatus = assetAcceptRejectStatus;
//       resetFunction = resetAssetAcceptRejectStatus;
//       statusError = error;
//     } else if (currentTabType === 'assetRevaluation') {
//       acceptRejectStatus = revaluationAcceptRejectStatus;
//       resetFunction = resetRevaluationAcceptRejectStatus;
//       statusError = error;
//     } else if (currentTabType === 'contributionRequest') {
//       if (
//         contributionAcceptRejectResponse?.results &&
//         Array.isArray(contributionAcceptRejectResponse.results) &&
//         contributionAcceptRejectResponse.results.length > 0
//       ) {
//         acceptRejectStatus = 'succeeded';
//       } else if (contributionAcceptRejectError) {
//         acceptRejectStatus = 'failed';
//       }
//       resetFunction = clearAcceptRejectResponse;
//       statusError = contributionAcceptRejectError;
//     }
//     // Handle unit sell request status
//     else if (currentTabType === 'unitSell') {
//       if (acceptRejectSellUnitsResponse?.success) {
//         acceptRejectStatus = 'succeeded';
//       } else if (acceptRejectSellUnitsError) {
//         acceptRejectStatus = 'failed';
//       }
//       resetFunction = clearAcceptRejectSellUnitsResponse;
//       statusError = acceptRejectSellUnitsError;
//     }

//     // Handle success
//     if (acceptRejectStatus === 'succeeded' && isAdmin) {
//       const hasResults =
//         contributionAcceptRejectResponse?.results &&
//         Array.isArray(contributionAcceptRejectResponse.results) &&
//         contributionAcceptRejectResponse.results.length > 0;

//       const resultCount =
//         hasResults && contributionAcceptRejectResponse.results
//           ? contributionAcceptRejectResponse.results.length
//           : 0;

//       const isBatchOperation = batchConfirmDialogOpen || resultCount > 1;

//       if (currentTabType === 'contributionRequest') {
//         if (isBatchOperation) {
//           if (hasResults && contributionAcceptRejectResponse.results) {
//             const successCount = contributionAcceptRejectResponse.results.filter(
//               (r) => r.success
//             ).length;

//             setSnackbar({
//               open: true,
//               message:
//                 contributionAcceptRejectResponse.message ||
//                 `Successfully processed ${successCount} out of ${resultCount} requests`,
//               severity: successCount === resultCount ? 'success' : 'warning'
//             });
//           }

//           setBatchConfirmDialogOpen(false);
//         } else {
//           const firstResult = contributionAcceptRejectResponse?.results?.[0];
//           setSnackbar({
//             open: true,
//             message:
//               firstResult?.message ||
//               contributionAcceptRejectResponse?.message ||
//               `Request ${actionType}ed successfully!`,
//             severity: 'success'
//           });

//           setConfirmDialogOpen(false);
//         }

//         if (resetFunction) {
//           dispatch(resetFunction());
//         }

//         if (currentTabConfig?.isActive) {
//           const unitType = currentTabConfig?.subscriptionType;
//           const payload: GetContributionRequestsPayload = {
//             groupId: selectedProjectId || '',
//             serviceId: 'fundManagementInvestment',
//             unitType: unitType as 'growthUnits' | 'incomeUnits',
//             frequency: 'daily',
//             pageSize: 100,
//             continuationToken: null
//           };
//           dispatch(getContributionRequests(payload) as any);
//         }
//       }
//       // Handle unit sell success
//       else if (currentTabType === 'unitSell') {
//         setSnackbar({
//           open: true,
//           message:
//             acceptRejectSellUnitsResponse?.message || `Request ${actionType}ed successfully!`,
//           severity: 'success'
//         });

//         setConfirmDialogOpen(false);

//         if (resetFunction) {
//           dispatch(resetFunction());
//         }

//         if (currentTabConfig?.isActive) {
//           loadTabData(currentTabConfig);
//         }
//       } else {
//         setSnackbar({
//           open: true,
//           message: `Request ${actionType}ed successfully!`,
//           severity: 'success'
//         });

//         setConfirmDialogOpen(false);

//         if (resetFunction) {
//           dispatch(resetFunction());
//         }

//         if (currentTabConfig?.isActive) {
//           loadTabData(currentTabConfig);
//         }
//       }
//     } else if (acceptRejectStatus === 'failed' && statusError) {
//       setSnackbar({
//         open: true,
//         message: statusError,
//         severity: 'error'
//       });
//       setConfirmDialogOpen(false);
//       setBatchConfirmDialogOpen(false);

//       if (resetFunction) {
//         dispatch(resetFunction());
//       }
//     }
//   }, [
//     unitsAcceptRejectStatus,
//     assetAcceptRejectStatus,
//     revaluationAcceptRejectStatus,
//     contributionAcceptRejectResponse,
//     contributionAcceptRejectError,
//     acceptRejectSellUnitsResponse,
//     acceptRejectSellUnitsError,
//     error,
//     actionType,
//     dispatch,
//     activeTab,
//     isAdmin,
//     tabConfigs.length,
//     batchConfirmDialogOpen,
//     selectedProjectId
//   ]);

//   // ✅ Load tab data with assetSellRequest handling
//   const loadTabData = (tabConfig: TabConfig) => {
//     const unitType = tabConfig?.subscriptionType;

//     if (tabConfig.tabType === 'unitsSubscription') {
//       const payload: GetPurchaseRequestsPayload = {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         unitType: unitType,
//         pageSize: 100,
//         continuationToken: null
//       };

//       if (!isAdmin && investorEmail) {
//         payload.filters = { investorEmailId: investorEmail };
//       }
//       dispatch(getPurchaseUnitsRequests(payload) as any);
//     } else if (tabConfig.tabType === 'assetPurchase') {
//       const payload: GetAssetRequestsPayload = {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         unitType: unitType,
//         pageSize: 100,
//         continuationToken: null
//       };
//       dispatch(getPurchaseAssetRequests(payload) as any);
//     } else if (tabConfig.tabType === 'assetRevaluation') {
//       const payload: GetRevaluationRequestsPayload = {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         unitType: unitType,
//         pageSize: 100,
//         continuationToken: null
//       };
//       dispatch(getRevaluationAssetRequests(payload) as any);
//     } else if (tabConfig.tabType === 'contributionRequest') {
//       const payload: GetContributionRequestsPayload = {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         unitType: unitType as 'growthUnits' | 'incomeUnits',
//         frequency: 'daily',
//         pageSize: 100,
//         continuationToken: null
//       };
//       dispatch(getContributionRequests(payload) as any);
//     } else if (tabConfig.tabType === 'unitSell') {
//       const payload: GetSellRequestsPayload = {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         unitType: unitType,
//         pageSize: 100,
//         continuationToken: null
//       };
//       dispatch(getSellUnitsRequests(payload) as any);
//     } else if (tabConfig.tabType === 'assetSellRequest') {
//       // ✅ Load asset sell requests from simulation slice
//       const payload: GetSellAssetRequestsPayload = {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         unitType: unitType as 'incomeUnits' | 'growthUnits',
//         pageSize: 100,
//         currentPage: 1
//       };
//       dispatch(getSellAssetRequests(payload) as any);
//     }
//   };

//   const callRevisedLandingDataAPI = async (unitType: string) => {
//     try {
//       const payload = {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         isAdmin: isAdmin
//       };
//       dispatch(getLandingData(payload) as any);
//     } catch (error) {
//       console.error('Landing data API error:', error);
//     }
//   };

//   // Helper to show certificate modal
//   const handleShowCertificate = (request: PurchaseRequest, unitType: string) => {
//     setCertificatePayload({
//       mode: 'api',
//       payload: {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         unitType: unitType as 'incomeUnits' | 'growthUnits',
//         investorEmail: request.investorEmailId
//       }
//     });
//     setShowCertificateModal(true);
//   };

//   // ✅ UPDATED: executeAction with unit sell request handling
//   const executeAction = async () => {
//     if (!selectedRequest) return;

//     const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
//     const currentTabConfig = tabConfigs[currentIndex];
//     const unitType = currentTabConfig?.subscriptionType;
//     const requestId = getRequestId(selectedRequest);
//     const action = actionType === 'accept' ? 'accepted' : 'rejected';

//     // Handle contribution request
//     if (currentTabConfig?.tabType === 'contributionRequest') {
//       const contributionReq = selectedRequest as ContributionRequest;
//       const payload: AcceptRejectRequestPayload = {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         unitType: unitType as 'incomeUnits' | 'growthUnits',
//         requests: [
//           {
//             frequency: contributionReq.frequency || 'monthly',
//             date: contributionReq.date || new Date().toISOString().split('T')[0],
//             requestId,
//             action: action as 'accepted' | 'rejected'
//           }
//         ]
//       };

//       dispatch(acceptRejectContributionRequest(payload) as any);
//       callRevisedLandingDataAPI(unitType);
//       return;
//     }

//     // ✅ Handle asset sell request
//   if (currentTabConfig?.tabType === 'assetSellRequest') {
//     const assetSellReq = selectedRequest as SellAssetRequestItem;

//     const payload: AcceptRejectSellAssetRequestPayload = {
//       groupId: selectedProjectId!,
//       serviceId: 'fundManagementInvestment',
//       unitType: currentTabConfig.subscriptionType as 'incomeUnits' | 'growthUnits',
//       assetSellId: assetSellReq.assetSellId,
//       action, // ONLY THIS (not actionType)
//       date_str: new Date().toISOString().split('T')[0]
//     };

//     dispatch(acceptRejectSellAssetRequest(payload));
//   }


//     // ✅ NEW: Handle unit sell request
//     if (currentTabConfig?.tabType === 'unitSell') {
//       const sellReq = selectedRequest as SellRequest;

//       const payload: AcceptRejectSellUnitsPayload = {
//         groupId: selectedProjectId!,
//         serviceId: 'fundManagementInvestment',
//         unitType: unitType as 'incomeUnits' | 'growthUnits',
//         requestId: requestId,
//         date_str: sellReq.requestDate || '',
//         action: action as 'accepted' | 'rejected'
//       };

//       dispatch(acceptRejectSellUnitsRequest(payload) as any);
//       callRevisedLandingDataAPI(unitType);
//       return;
//     }

//     // Existing logic for other request types
//     if (
//       'investorName' in selectedRequest &&
//       !('sellUnits' in selectedRequest) &&
//       !('frequency' in selectedRequest)
//     ) {
//       const purchaseReq = selectedRequest as PurchaseRequest;
//       const payload: AcceptRejectUnitsPayload = {
//         groupId: selectedProjectId!,
//         serviceId: 'fundManagementInvestment',
//         unitType,
//         requestId,
//         date_str: purchaseReq?.date_str || '',
//         fromMarketplace: purchaseReq?.fromMarketplace || false,
//         action
//       };

//       const result = await dispatch(acceptRejectUnitsRequest(payload) as any);

//       // ✅ NEW: Show certificate on accept for income/growth units only
//       if (
//         acceptRejectUnitsRequest.fulfilled.match(result) &&
//         actionType === 'accept' &&
//         (unitType === 'incomeUnits' || unitType === 'growthUnits')
//       ) {
//         handleShowCertificate(purchaseReq, unitType);
//       }
//     } else if ('asset' in selectedRequest && 'assetData' in selectedRequest.asset) {
//       const payload: AcceptRejectRevaluationPayload = {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         unitType,
//         requestId,
//         action
//       };
//       dispatch(acceptRejectRevaluationRequest(payload) as any);
//     } else if ('asset' in selectedRequest) {
//       const payload: AcceptRejectAssetPayload = {
//         groupId: selectedProjectId || '',
//         serviceId: 'fundManagementInvestment',
//         unitType,
//         requestId,
//         action
//       };
//       dispatch(acceptRejectAssetRequest(payload) as any);
//     }

//     callRevisedLandingDataAPI(unitType);
//   };

//   const executeBatchAction = async () => {
//     const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
//     const currentTabConfig = tabConfigs[currentIndex];
//     const unitType = currentTabConfig?.subscriptionType;

//     if (currentTabConfig?.tabType !== 'contributionRequest') {
//       return;
//     }

//     const pendingContributionRequests = (contributionRequests || []).filter(
//       (req) => req.status === 'pending'
//     ) as ContributionRequest[];

//     if (pendingContributionRequests.length === 0) {
//       setSnackbar({
//         open: true,
//         message: 'No pending requests to process',
//         severity: 'info'
//       });
//       setBatchConfirmDialogOpen(false);
//       return;
//     }

//     const action = batchActionType === 'accept' ? 'accepted' : 'rejected';

//     const payload: AcceptRejectRequestPayload = {
//       groupId: selectedProjectId || '',
//       serviceId: 'fundManagementInvestment',
//       unitType: unitType as 'incomeUnits' | 'growthUnits',
//       requests: pendingContributionRequests.map((req) => ({
//         frequency: req.frequency || 'monthly',
//         date: req.date || new Date().toISOString().split('T')[0],
//         requestId: getRequestId(req),
//         action: action as 'accepted' | 'rejected'
//       }))
//     };

//     dispatch(acceptRejectContributionRequest(payload) as any);
//     callRevisedLandingDataAPI(unitType);
//   };

//   const handleAction = (
//     request:
//       | PurchaseRequest
//       | AssetRequest
//       | RevaluationRequest
//       | ContributionRequest
//       | SellRequest
//       | SellAssetRequestItem,
//     action: 'accept' | 'reject'
//   ) => {
//     setSelectedRequest(request);
//     setActionType(action);
//     setConfirmDialogOpen(true);
//   };

//   const handleBatchAction = (action: 'accept' | 'reject') => {
//     setBatchActionType(action);
//     setBatchConfirmDialogOpen(true);
//   };

//   const handleViewRequest = (
//     request:
//       | PurchaseRequest
//       | AssetRequest
//       | RevaluationRequest
//       | ContributionRequest
//       | SellRequest
//       | SellAssetRequestItem
//   ) => {
//     setSelectedRequest(request);
//     setDialogOpen(true);
//   };

//   const isContributionRequest = (
//     req:
//       | PurchaseRequest
//       | AssetRequest
//       | RevaluationRequest
//       | ContributionRequest
//       | SellRequest
//       | SellAssetRequestItem
//   ): req is ContributionRequest => {
//     return (
//       'frequency' in req &&
//       'contributionAmount' in req &&
//       'investorEmailId' in req &&
//       !('asset' in req)
//     );
//   };

//   // ✅ Get current tab data including asset sell requests
//   const getCurrentTabData = () => {
//     const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
//     const currentTabConfig = tabConfigs[currentIndex];

//     if (!currentTabConfig) {
//       return {
//         all: [],
//         pending: [],
//         accepted: [],
//         rejected: [],
//         isActive: false
//       };
//     }

//     let requests: any[] = [];

//     if (currentTabConfig.tabType === 'unitsSubscription') {
//       requests = purchaseRequests || [];
//     } else if (currentTabConfig.tabType === 'assetPurchase') {
//       requests = assetRequests || [];
//     } else if (currentTabConfig.tabType === 'assetRevaluation') {
//       requests = revaluationRequests || [];
//     } else if (currentTabConfig.tabType === 'contributionRequest') {
//       requests = contributionRequests || [];
//     } else if (currentTabConfig.tabType === 'unitSell') {
//       const unitType = currentTabConfig?.subscriptionType;
//       requests = (sellRequests || []).filter((req) => req.unitType === unitType);
//     } else if (currentTabConfig.tabType === 'assetSellRequest') {
//       // ✅ Get asset sell requests
//       const unitType = currentTabConfig?.subscriptionType;
//       requests = (sellAssetRequestsData?.sellAssetRequests || []).filter(
//         (req) => req.unitType === unitType
//       );
//     }

//     const filteredData = filterRequests(requests, filterStatus, searchTerm) || [];

//     return {
//       all: filteredData,
//       pending: filteredData.filter((r) => r.status === 'pending'),
//       accepted: filteredData.filter((r) => r.status === 'accepted' || r.status === 'approved'),
//       rejected: filteredData.filter((r) => r.status === 'rejected'),
//       isActive: currentTabConfig.isActive || false
//     };
//   };

//   const TabPanel = ({
//     children,
//     value,
//     index
//   }: {
//     children: React.ReactNode;
//     value: number;
//     index: number;
//   }) => (
//     <div hidden={value !== index} {...(value === index && { id: `tabpanel-${index}` })}>
//       {value === index && <Box>{children}</Box>}
//     </div>
//   );

//   if (tabConfigs.length === 0) {
//     return (
//       <Container maxWidth="xl" sx={{ padding: 3, textAlign: 'center' }}>
//         <Alert severity="info">No transaction types are available for your role.</Alert>
//       </Container>
//     );
//   }

//   const currentTabData = getCurrentTabData();
//   const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
//   const currentTabConfig = tabConfigs[currentIndex];

//   // ✅ UPDATED: Include sell units loading
//   const isActionLoading =
//     loading ||
//     sellAssetRequestsLoading ||
//     (currentTabConfig?.tabType === 'contributionRequest' && contributionAcceptRejectLoading) ||
//     (currentTabConfig?.tabType === 'unitSell' && acceptRejectSellUnitsLoading);

//   const isContributionTab = currentTabConfig?.tabType === 'contributionRequest';
//   const hasPendingContributions = currentTabData?.pending.length > 0;


//    useEffect(() => {
//      if (acceptRejectSellAssetResponse?.success) {
//        setSnackbar({
//          open: true,
//          message: acceptRejectSellAssetResponse.message,
//          severity: 'success'
//        });
//        setConfirmDialogOpen(false); // Close the confirmation modal here upon success

//        // refresh sell asset requests list if needed
//        dispatch(
//          getSellAssetRequests({
//            groupId: selectedProjectId!,
//            serviceId: 'fundManagementInvestment',
//            unitType: currentTabConfig?.subscriptionType as 'incomeUnits' | 'growthUnits'
//          })
//        );
//      }
//    }, [acceptRejectSellAssetResponse, dispatch, selectedProjectId, ]);
//   return (
//     <Container maxWidth="xl" sx={{ padding: { xs: 1, sm: 2, md: 3 }, minHeight: '100vh' }}>
//       {/* Header */}
//       <Box
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           marginBottom: { xs: 2, md: 3 },
//           flexWrap: 'wrap',
//           gap: { xs: 1, md: 0 }
//         }}
//       >
//         <Box
//           sx={{
//             width: { xs: 32, md: 40 },
//             height: { xs: 32, md: 40 },
//             borderRadius: 2,
//             background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             marginRight: { xs: 1.5, md: 2 }
//           }}
//         >
//           <FaDollarSign size={isMobile ? 16 : 20} color="white" />
//         </Box>
//         <Box sx={{ flex: 1, minWidth: 0 }}>
//           <Typography
//             variant="h6"
//             component="h1"
//             sx={{ fontWeight: 500, color: '#333', fontSize: { xs: '1rem', md: '1.2rem' } }}
//           >
//             {isAdmin ? 'Fund Management Approvals' : 'Fund Management Requests'}
//           </Typography>
//           <Typography
//             variant="body2"
//             sx={{ color: '#666', marginTop: 0.5, fontSize: { xs: '0.75rem', md: '0.8rem' } }}
//           >
//             {isAdmin
//               ? 'Review and manage fund transactions and requests'
//               : 'View your fund transaction requests'}
//           </Typography>
//         </Box>
//       </Box>

//       {/* Search and Filter */}
//       <Paper
//         sx={{
//           padding: { xs: 1.5, md: 2 },
//           borderRadius: 3,
//           marginBottom: { xs: 2, md: 3 },
//           backgroundColor: '#f8f9fa'
//         }}
//       >
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={isContributionTab && isAdmin ? 4 : 8}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder="Search by name, email..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               InputProps={{
//                 startAdornment: <FaSearch color="#999" style={{ marginRight: 8 }} size={14} />
//               }}
//               sx={{
//                 '& .MuiOutlinedInput-root': {
//                   borderRadius: 2,
//                   backgroundColor: 'white'
//                 }
//               }}
//             />
//           </Grid>
//           <Grid item xs={12} md={isContributionTab && isAdmin ? 3 : 4}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Status Filter</InputLabel>
//               <Select
//                 value={filterStatus}
//                 label="Status Filter"
//                 onChange={(e) => setFilterStatus(e.target.value)}
//                 sx={{ borderRadius: 2, backgroundColor: 'white' }}
//               >
//                 <MenuItem value="all">All Status</MenuItem>
//                 <MenuItem value="pending">Pending</MenuItem>
//                 <MenuItem value="accepted">Accepted</MenuItem>
//                 <MenuItem value="approved">Approved</MenuItem>
//                 <MenuItem value="rejected">Rejected</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
//           {isContributionTab && isAdmin && (
//             <Grid item xs={12} md={5}>
//               <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
//                 <Tooltip
//                   title={
//                     hasPendingContributions
//                       ? `Accept all ${currentTabData?.pending.length} pending requests`
//                       : 'No pending requests'
//                   }
//                   arrow
//                 >
//                   <span>
//                     <Badge
//                       badgeContent={currentTabData?.pending.length}
//                       color="primary"
//                       max={99}
//                       sx={{
//                         '& .MuiBadge-badge': {
//                           backgroundColor: hasPendingContributions ? '#4caf50' : '#bdbdbd'
//                         }
//                       }}
//                     >
//                       <Button
//                         variant="contained"
//                         size="small"
//                         startIcon={<FaCheckDouble size={14} />}
//                         onClick={() => handleBatchAction('accept')}
//                         disabled={!hasPendingContributions || contributionAcceptRejectLoading}
//                         sx={{
//                           backgroundColor: '#4caf50',
//                           '&:hover': { backgroundColor: '#45a049' },
//                           textTransform: 'none',
//                           fontSize: '0.75rem',
//                           borderRadius: 2
//                         }}
//                       >
//                         Accept All
//                       </Button>
//                     </Badge>
//                   </span>
//                 </Tooltip>
//                 <Tooltip
//                   title={
//                     hasPendingContributions
//                       ? `Reject all ${currentTabData?.pending.length} pending requests`
//                       : 'No pending requests'
//                   }
//                   arrow
//                 >
//                   <span>
//                     <Badge badgeContent={currentTabData?.pending.length} color="error" max={99}>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         startIcon={<FaTimesCircle size={14} />}
//                         onClick={() => handleBatchAction('reject')}
//                         disabled={!hasPendingContributions || contributionAcceptRejectLoading}
//                         sx={{
//                           color: '#f44336',
//                           borderColor: '#f44336',
//                           '&:hover': { backgroundColor: '#ffebee', borderColor: '#f44336' },
//                           textTransform: 'none',
//                           fontSize: '0.75rem',
//                           borderRadius: 2
//                         }}
//                       >
//                         Reject All
//                       </Button>
//                     </Badge>
//                   </span>
//                 </Tooltip>
//               </Box>
//             </Grid>
//           )}
//         </Grid>
//       </Paper>

//       {/* ✅ UPDATED: Error display including sell units error */}
//       {(error ||
//         contributionAcceptRejectError ||
//         sellAssetRequestsError ||
//         acceptRejectSellUnitsError) && (
//         <Alert
//           severity="error"
//           sx={{ marginBottom: 2 }}
//           onClose={() => {
//             dispatch(clearError());
//             dispatch(clearAcceptRejectResponse());
//             dispatch(clearAcceptRejectSellUnitsResponse());
//           }}
//         >
//           {error ||
//             contributionAcceptRejectError ||
//             sellAssetRequestsError ||
//             acceptRejectSellUnitsError}
//         </Alert>
//       )}

//       <Paper sx={{ borderRadius: 3, overflow: 'hidden' }}>
//         <Box sx={{ backgroundColor: 'white', borderBottom: '1px solid #e0e0e0' }}>
//           <Tabs
//             value={activeTab}
//             onChange={(e, newValue) => {
//               if (newValue >= 0 && newValue < tabConfigs.length) {
//                 setActiveTab(newValue);
//               }
//             }}
//             variant="scrollable"
//             scrollButtons="auto"
//             sx={{
//               minHeight: 56,
//               '& .MuiTab-root': {
//                 color: '#666',
//                 fontWeight: 400,
//                 fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
//                 textTransform: 'none',
//                 minWidth: { xs: 90, sm: 110, md: 140 },
//                 maxWidth: 'none',
//                 padding: { xs: '8px 10px', sm: '10px 12px', md: '12px 16px' },
//                 whiteSpace: 'nowrap',
//                 flexShrink: 0,
//                 transition: 'all 0.2s ease',
//                 '&:hover': {
//                   color: '#1976d2',
//                   backgroundColor: 'rgba(25, 118, 210, 0.04)'
//                 }
//               },
//               '& .Mui-selected': {
//                 color: '#1976d2',
//                 fontWeight: 600
//               },
//               '& .MuiTabs-indicator': {
//                 backgroundColor: '#1976d2',
//                 height: 3,
//                 borderRadius: '3px 3px 0 0'
//               }
//             }}
//           >
//             {tabConfigs?.map((tab) => (
//               <Tab
//                 key={tab?.key}
//                 label={
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: 0.5,
//                       minWidth: 'fit-content',
//                       whiteSpace: 'nowrap'
//                     }}
//                   >
//                     {tab?.icon}
//                     <span>{tab?.label}</span>
//                     {!tab?.isActive && (
//                       <Button
//                         size="small"
//                         sx={{
//                           height: 16,
//                           fontSize: '0.5rem',
//                           backgroundColor: '#e0e0e0',
//                           color: '#666',
//                           marginLeft: 0.5,
//                           textTransform: 'none',
//                           minWidth: 'unset',
//                           padding: '0 4px'
//                         }}
//                       >
//                         Soon
//                       </Button>
//                     )}
//                   </Box>
//                 }
//               />
//             ))}
//           </Tabs>
//         </Box>

//         <Box sx={{ padding: { xs: 1, md: 2 } }}>
//           {tabConfigs?.map((tabConfig, tabIndex) => (
//             <TabPanel key={tabConfig.key} value={activeTab} index={tabIndex}>
//               {tabConfig?.isActive ? (
//                 isActionLoading ? (
//                   <Box sx={{ textAlign: 'center', py: 4 }}>
//                     <CircularProgress />
//                     <Typography variant="body2" sx={{ mt: 2, fontSize: '0.8rem' }}>
//                       Loading {tabConfig?.label?.toLowerCase()}...
//                     </Typography>
//                   </Box>
//                 ) : (
//                   <Grid container spacing={2}>
//                     {currentTabData?.all.length > 0 ? (
//                       currentTabData?.all.map((request) => (
//                         <Grid item xs={12} sm={6} lg={4} key={getRequestId(request)}>
//                           <RequestCard
//                             request={request}
//                             tabConfig={currentTabConfig}
//                             onViewRequest={handleViewRequest}
//                             onAction={handleAction}
//                             loading={isActionLoading}
//                           />
//                         </Grid>
//                       ))
//                     ) : (
//                       <Grid item xs={12}>
//                         <Box sx={{ textAlign: 'center', py: 4 }}>
//                           <Typography variant="body1" sx={{ color: '#666', fontSize: '0.9rem' }}>
//                             No {tabConfig.label.toLowerCase()} requests found
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{ color: '#999', fontSize: '0.75rem', mt: 1 }}
//                           >
//                             {tabConfig.description}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     )}
//                   </Grid>
//                 )
//               ) : (
//                 <Box sx={{ textAlign: 'center', py: 8 }}>
//                   <Box sx={{ marginBottom: 3, opacity: 0.5 }}>{tabConfig.icon}</Box>
//                   <Typography
//                     variant="h6"
//                     sx={{ marginBottom: 1, fontSize: '1rem', fontWeight: 500 }}
//                   >
//                     {tabConfig.label}
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{ color: '#666', fontSize: '0.8rem', marginBottom: 2 }}
//                   >
//                     {tabConfig.description}
//                   </Typography>
//                   <Box
//                     sx={{
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       padding: '8px 16px',
//                       backgroundColor: '#f0f0f0',
//                       borderRadius: 2
//                     }}
//                   >
//                     <FaClock size={14} color="#666" />
//                     <Typography variant="body2" sx={{ color: '#666', fontSize: '0.75rem' }}>
//                       Coming Soon - API Integration in Progress
//                     </Typography>
//                   </Box>
//                 </Box>
//               )}
//             </TabPanel>
//           ))}
//         </Box>
//       </Paper>

//       {/* Request Details Dialog */}
//       <RequestDialog
//         open={dialogOpen}
//         request={selectedRequest as any}
//         onClose={() => setDialogOpen(false)}
//       />

//       {/* Single Request Confirmation Dialog */}
//       {isAdmin && (
//         <Dialog
//           open={confirmDialogOpen}
//           onClose={() => setConfirmDialogOpen(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               backgroundColor: actionType === 'accept' ? '#e8f5e8' : '#ffebee',
//               color: actionType === 'accept' ? '#2e7d32' : '#c62828'
//             }}
//           >
//             <FaExclamationTriangle style={{ marginRight: 8 }} />
//             <Typography variant="h6" sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
//               Confirm {actionType === 'accept' ? 'Accept' : 'Reject'} Request
//             </Typography>
//           </DialogTitle>
//           <DialogContent sx={{ padding: 3 }}>
//             {selectedRequest && (
//               <Box>
//                 <Alert
//                   severity={actionType === 'accept' ? 'success' : 'warning'}
//                   sx={{ marginBottom: 2, fontSize: '0.75rem' }}
//                 >
//                   You are about to <strong>{actionType}</strong> this request.
//                   {(() => {
//                     if (isSellAssetRequest(selectedRequest)) {
//                       return ` Asset: ${selectedRequest.assetId}, Amount: ${formatCurrency(
//                         parseFloat(selectedRequest.finalPrice)
//                       )}`;
//                     } else if ('investedAmount' in selectedRequest) {
//                       return ` Amount: ${formatCurrency(selectedRequest.investedAmount)}`;
//                     } else if ('sellUnits' in selectedRequest) {
//                       const amount =
//                         parseFloat(selectedRequest.sellUnits) *
//                         parseFloat(selectedRequest.unitPrice);
//                       return ` Amount: ${formatCurrency(amount)}`;
//                     } else if (isContributionRequest(selectedRequest)) {
//                       return ` Amount: ${formatCurrency(selectedRequest.contributionAmount || 0)}`;
//                     }
//                     return '';
//                   })()}
//                 </Alert>
//               </Box>
//             )}
//           </DialogContent>
//           <DialogActions sx={{ padding: 2 }}>
//             <Button
//               onClick={() => setConfirmDialogOpen(false)}
//               disabled={isActionLoading}
//               sx={{ textTransform: 'none', fontSize: '0.75rem' }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={executeAction}
//               variant="contained"
//               disabled={isActionLoading}
//               startIcon={isActionLoading ? <CircularProgress size={16} /> : null}
//               sx={{
//                 backgroundColor: actionType === 'accept' ? '#4caf50' : '#f44336',
//                 textTransform: 'none',
//                 fontSize: '0.75rem',
//                 fontWeight: 500
//               }}
//             >
//               {isActionLoading
//                 ? 'Processing...'
//                 : `Confirm ${actionType === 'accept' ? 'Accept' : 'Reject'}`}
//             </Button>
//           </DialogActions>
//         </Dialog>
//       )}

//       {/* Batch Confirmation Dialog */}
//       {isAdmin && (
//         <Dialog
//           open={batchConfirmDialogOpen}
//           onClose={() => setBatchConfirmDialogOpen(false)}
//           maxWidth="sm"
//           fullWidth
//         >
//           <DialogTitle
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               backgroundColor: batchActionType === 'accept' ? '#e8f5e8' : '#ffebee',
//               color: batchActionType === 'accept' ? '#2e7d32' : '#c62828'
//             }}
//           >
//             <FaExclamationTriangle style={{ marginRight: 8 }} />
//             <Typography variant="h6" sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
//               Confirm {batchActionType === 'accept' ? 'Accept' : 'Reject'} All Pending Requests
//             </Typography>
//           </DialogTitle>
//           <DialogContent sx={{ padding: 3 }}>
//             <Alert
//               severity={batchActionType === 'accept' ? 'success' : 'warning'}
//               sx={{ marginBottom: 2, fontSize: '0.75rem' }}
//             >
//               You are about to <strong>{batchActionType}</strong> all{' '}
//               <strong>{currentTabData?.pending.length}</strong> pending contribution requests.
//               <br />
//               <br />
//               This action cannot be undone. Are you sure you want to continue?
//             </Alert>
//           </DialogContent>
//           <DialogActions sx={{ padding: 2 }}>
//             <Button
//               onClick={() => setBatchConfirmDialogOpen(false)}
//               disabled={contributionAcceptRejectLoading}
//               sx={{ textTransform: 'none', fontSize: '0.75rem' }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={executeBatchAction}
//               variant="contained"
//               disabled={contributionAcceptRejectLoading}
//               startIcon={
//                 contributionAcceptRejectLoading ? (
//                   <CircularProgress size={16} />
//                 ) : batchActionType === 'accept' ? (
//                   <FaCheckDouble size={14} />
//                 ) : (
//                   <FaTimesCircle size={14} />
//                 )
//               }
//               sx={{
//                 backgroundColor: batchActionType === 'accept' ? '#4caf50' : '#f44336',
//                 textTransform: 'none',
//                 fontSize: '0.75rem',
//                 fontWeight: 500
//               }}
//             >
//               {contributionAcceptRejectLoading
//                 ? 'Processing...'
//                 : `Confirm ${batchActionType === 'accept' ? 'Accept' : 'Reject'} All`}
//             </Button>
//           </DialogActions>
//         </Dialog>
//       )}

//       {/* Certificate Modal - ADD THIS BEFORE </Container> */}
//       {showCertificateModal && certificatePayload && (
//         <CertificateViewer
//           mode={certificatePayload.mode}
//           payload={certificatePayload.payload}
//           onClose={() => {
//             setShowCertificateModal(false);
//             setCertificatePayload(null);
//             dispatch(clearCurrentBuySellCertificateData());
//           }}
//         />
//       )}

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%', borderRadius: 2, fontSize: '0.75rem' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default ApprovalRequest;


import {
  Alert,
  Badge,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useAppSelector } from 'app/hooks';
import React, { useEffect, useState } from 'react';
import {
  FaArrowDown,
  FaArrowUp,
  FaBalanceScale,
  FaCalendarCheck,
  FaCheckDouble,
  FaClock,
  FaCoins,
  FaDollarSign,
  FaExclamationTriangle,
  FaSearch,
  FaShoppingCart,
  FaTimesCircle
} from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import {
  acceptRejectSellAssetRequest,
  AcceptRejectSellAssetRequestPayload,
  clearAcceptRejectSellAssetResponse, // ✅ ADD THIS
  clearCurrentBuySellCertificateData
} from 'slices/fundManagementInvestment/simulationDashboardSlice';
import CertificateViewer from '../certificate/CertificateViewer';

// Import Redux actions and selectors
import {
  acceptRejectAssetRequest,
  acceptRejectRevaluationRequest,
  acceptRejectUnitsRequest,
  clearError,
  getContributionRequests,
  getLandingData,
  getPurchaseAssetRequests,
  getPurchaseUnitsRequests,
  getRevaluationAssetRequests,
  getSellUnitsRequests,
  resetAssetAcceptRejectStatus,
  resetRevaluationAcceptRejectStatus,
  resetUnitsAcceptRejectStatus,
  selectAssetAcceptRejectStatus,
  selectAssetRequests,
  selectContributionRequests,
  selectContributionRequestsStatus,
  selectError,
  selectLoading,
  selectPurchaseRequests,
  selectRevaluationAcceptRejectStatus,
  selectRevaluationRequests,
  selectRevaluationRequestsStatus,
  selectUnitsAcceptRejectStatus,
  type AcceptRejectAssetPayload,
  type AcceptRejectRevaluationPayload,
  type AcceptRejectUnitsPayload,
  type GetSellRequestsPayload
} from '../../../slices/fundManagementInvestment/fundmanagementInvestmentSlice';

// ✅ Import from simulation slice
import {
  acceptRejectContributionRequest,
  acceptRejectSellUnitsRequest,
  clearAcceptRejectResponse,
  clearAcceptRejectSellUnitsResponse,
  getSellAssetRequests,
  type AcceptRejectRequestPayload,
  type AcceptRejectSellUnitsPayload,
  type GetSellAssetRequestsPayload,
  type SellAssetRequestItem
} from 'slices/fundManagementInvestment/simulationDashboardSlice';

// Import local components and utilities
import { useDrawer } from 'components/app/DrawerContext';
import RequestCard from './RequestCard';
import RequestDialog from './RequestDialog';
import {
  AssetRequest,
  ContributionRequest,
  GetAssetRequestsPayload,
  GetContributionRequestsPayload,
  GetPurchaseRequestsPayload,
  GetRevaluationRequestsPayload,
  LocationState,
  PurchaseRequest,
  RevaluationRequest,
  SellRequest,
  SnackbarState,
  TabConfig
} from './types';
import { filterRequests, formatCurrency, getInvestorEmail, isAdminLogin } from './utils';

// Type guard for SellAssetRequestItem
const isSellAssetRequest = (req: any): req is SellAssetRequestItem => {
  return req && 'assetSellId' in req && 'assetId' in req;
};

// Helper to get requestId from any request type
const getRequestId = (request: any): string => {
  if ('requestId' in request) {
    return request.requestId;
  }
  if ('assetSellId' in request) {
    return request.assetSellId;
  }
  return '';
};

const ApprovalRequest: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const locationState = (location.state as LocationState) || undefined;

  console.log('Location State:', locationState);

  // ✅ Support both 'to' and 'unitType' parameters
  const { from, to, unitType, isAdmin: locationIsAdmin } = locationState || {};

  // Use whichever is provided (to takes priority)
  const routeUnitType = to || unitType;

  // Use drawer context for admin state management
  const { fundManagementAdminRight, setFundManagementAdminRight } = useDrawer();

  // Certificate modal state
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [certificatePayload, setCertificatePayload] = useState<any>(null);

  // Calculate admin status and update context
  useEffect(() => {
    const calculatedIsAdmin = isAdminLogin({ isAdmin: locationIsAdmin });
    setFundManagementAdminRight(calculatedIsAdmin);
  }, [locationIsAdmin, setFundManagementAdminRight]);

  const isAdmin = locationIsAdmin || fundManagementAdminRight;
  const dispatch = useDispatch();

  // Redux selectors
  const purchaseRequests = useSelector(selectPurchaseRequests) as PurchaseRequest[];
  const assetRequests = useSelector(selectAssetRequests) as AssetRequest[];
  const revaluationRequests = useSelector(selectRevaluationRequests) as RevaluationRequest[];
  const contributionRequests = useSelector(selectContributionRequests) as ContributionRequest[];
  const sellRequests = useSelector(
    (state: any) => state.fundManagementInvestment.sellRequests
  ) as SellRequest[];
  const loading = useSelector(selectLoading);
  const error = useSelector(selectError);
  const unitsAcceptRejectStatus = useSelector(selectUnitsAcceptRejectStatus);
  const assetAcceptRejectStatus = useSelector(selectAssetAcceptRejectStatus);
  const revaluationRequestsStatus = useSelector(selectRevaluationRequestsStatus);
  const revaluationAcceptRejectStatus = useSelector(selectRevaluationAcceptRejectStatus);
  const contributionRequestsStatus = useSelector(selectContributionRequestsStatus);

  // ✅ Get asset sell requests from simulation slice
  const sellAssetRequestsLoading = useAppSelector(
    (state) => state.simulationDashboard?.sellAssetRequestsLoading || false
  );
  const sellAssetRequestsError = useAppSelector(
    (state) => state.simulationDashboard?.sellAssetRequestsError || null
  );
  const sellAssetRequestsData = useAppSelector(
    (state) => state.simulationDashboard?.sellAssetRequestsData || null
  );
  const acceptRejectSellAssetResponse = useAppSelector(
    (state) => state.simulationDashboard.acceptRejectSellAssetResponse
  );
  const acceptRejectSellAssetLoading = useAppSelector(
    (state) => state.simulationDashboard?.acceptRejectSellAssetLoading || false
  );

  // Get unified contribution accept/reject state from simulation slice
  const contributionAcceptRejectLoading = useAppSelector(
    (state) => state.simulationDashboard?.acceptRejectLoading || false
  );
  const contributionAcceptRejectError = useAppSelector(
    (state) => state.simulationDashboard?.acceptRejectError || null
  );
  const contributionAcceptRejectResponse = useAppSelector(
    (state) => state.simulationDashboard?.acceptRejectResponse || null
  );

  // ✅ Get sell units accept/reject state from simulation slice
  const acceptRejectSellUnitsLoading = useAppSelector(
    (state) => state.simulationDashboard?.acceptRejectSellUnitsLoading || false
  );
  const acceptRejectSellUnitsError = useAppSelector(
    (state) => state.simulationDashboard?.acceptRejectSellUnitsError || null
  );
  const acceptRejectSellUnitsResponse = useAppSelector(
    (state) => state.simulationDashboard?.acceptRejectSellUnitsResponse || null
  );

  // Project and service info
  const selectedProjectId = useAppSelector((state) => state.homeTilesServices.selectedProjectId);
  const selectedServiceTitle = useAppSelector((state) => {
    return state.serviceSelected.selectedServiceTitle;
  });

  const investorEmail = getInvestorEmail();

  // ✅ Tab configurations WITH NEW ASSET SELL REQUEST TABS
  const allTabConfigs: TabConfig[] = [
    {
      key: 'incomeUnits',
      label: 'Income Units',
      icon: <FaCoins size={16} />,
      description: 'Income unit subscription requests',
      subscriptionType: 'incomeUnits',
      isActive: true,
      tabType: 'unitsSubscription'
    },
    {
      key: 'growthUnits',
      label: 'Growth Units',
      icon: <FaArrowUp size={16} />,
      description: 'Growth unit subscription requests',
      subscriptionType: 'growthUnits',
      isActive: true,
      tabType: 'unitsSubscription'
    },
    {
      key: 'assetPurchase',
      label: 'Income Asset Purchase',
      icon: <FaShoppingCart size={16} />,
      description: 'Income asset purchase requests',
      subscriptionType: 'incomeUnits',
      isActive: true,
      tabType: 'assetPurchase'
    },
    {
      key: 'growthAssetPurchase',
      label: 'Growth Asset Purchase',
      icon: <FaShoppingCart size={16} />,
      description: 'Growth asset purchase requests',
      subscriptionType: 'growthUnits',
      isActive: true,
      tabType: 'assetPurchase'
    },
    {
      key: 'incomeContribution',
      label: 'Income Contribution',
      icon: <FaCalendarCheck size={16} />,
      description: 'Income contribution requests',
      subscriptionType: 'incomeUnits',
      isActive: true,
      tabType: 'contributionRequest',
      adminOnly: true
    },
    {
      key: 'growthContribution',
      label: 'Growth Contribution',
      icon: <FaCalendarCheck size={16} />,
      description: 'Growth contribution requests',
      subscriptionType: 'growthUnits',
      isActive: true,
      tabType: 'contributionRequest',
      adminOnly: true
    },
    {
      key: 'incomeAssetRevaluation',
      label: 'Income Asset Revaluation',
      icon: <FaBalanceScale size={16} />,
      description: 'Income asset revaluation requests',
      subscriptionType: 'incomeUnits',
      isActive: true,
      tabType: 'assetRevaluation'
    },
    {
      key: 'growthAssetRevaluation',
      label: 'Growth Asset Revaluation',
      icon: <FaBalanceScale size={16} />,
      description: 'Growth asset revaluation requests',
      subscriptionType: 'growthUnits',
      isActive: true,
      tabType: 'assetRevaluation'
    },
    {
      key: 'incomeUnitSell',
      label: 'Income Unit Sell',
      icon: <FaArrowDown size={16} />,
      description: 'Income unit sell requests',
      subscriptionType: 'incomeUnits',
      isActive: true,
      tabType: 'unitSell'
    },
    {
      key: 'growthUnitSell',
      label: 'Growth Unit Sell',
      icon: <FaArrowDown size={16} />,
      description: 'Growth unit sell requests',
      subscriptionType: 'growthUnits',
      isActive: true,
      tabType: 'unitSell'
    },
    // ✅ NEW: Income Asset Sell Request tab
    {
      key: 'incomeAssetSellReq',
      label: 'Income Asset Sell',
      icon: <FaArrowDown size={16} />,
      description: 'Income asset sell requests',
      subscriptionType: 'incomeUnits',
      isActive: true,
      tabType: 'assetSellRequest',
      adminOnly: true
    },
    // ✅ NEW: Growth Asset Sell Request tab
    {
      key: 'growthAssetSellReq',
      label: 'Growth Asset Sell',
      icon: <FaArrowDown size={16} />,
      description: 'Growth asset sell requests',
      subscriptionType: 'growthUnits',
      isActive: true,
      tabType: 'assetSellRequest',
      adminOnly: true
    }
  ];

  // Filter tabs based on admin status
  const tabConfigs = isAdmin
    ? allTabConfigs
    : allTabConfigs.filter(
        (tab) =>
          !tab.adminOnly &&
          ['incomeUnits', 'growthUnits', 'incomeUnitSell', 'growthUnitSell'].includes(tab.key)
      );

  // ✅ UPDATED: getDefaultTabIndex with dual parameter support
  const getDefaultTabIndex = (): number => {
    let targetTabKey: string | null = null;

    if (from === 'unitPurchase') {
      targetTabKey = routeUnitType === 'growthUnits' ? 'growthUnits' : 'incomeUnits';
    } else if (from === 'purchaseAssets') {
      if (!isAdmin) return 0;
      targetTabKey = routeUnitType === 'growthUnits' ? 'growthAssetPurchase' : 'assetPurchase';
    } else if (from === 'assetSell') {
      if (!isAdmin) return 0;
      targetTabKey = routeUnitType === 'growthUnits' ? 'growthAssetSellReq' : 'incomeAssetSellReq';
    } else if (from === 'unitSell') {
      targetTabKey = routeUnitType === 'growthUnits' ? 'growthUnitSell' : 'incomeUnitSell';
    }

    // Find the index of the target tab
    if (targetTabKey) {
      const filteredIndex = tabConfigs.findIndex((tab) => tab.key === targetTabKey);
      return filteredIndex !== -1 ? filteredIndex : 0;
    }

    return 0;
  };

  const [activeTab, setActiveTab] = useState(() => {
    const defaultIndex = getDefaultTabIndex();
    return defaultIndex < tabConfigs.length ? defaultIndex : 0;
  });

  const [selectedRequest, setSelectedRequest] = useState<
    | PurchaseRequest
    | AssetRequest
    | RevaluationRequest
    | ContributionRequest
    | SellRequest
    | SellAssetRequestItem
    | null
  >(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [actionType, setActionType] = useState<'accept' | 'reject'>('accept');
  const [filterStatus, setFilterStatus] = useState<string>('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'success'
  });

  const [batchConfirmDialogOpen, setBatchConfirmDialogOpen] = useState(false);
  const [batchActionType, setBatchActionType] = useState<'accept' | 'reject'>('accept');

  useEffect(() => {
    if (activeTab >= tabConfigs.length) {
      setActiveTab(0);
    }
  }, [tabConfigs.length, activeTab]);

  useEffect(() => {
    if (selectedProjectId && tabConfigs.length > 0) {
      const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
      const defaultTab = tabConfigs[currentIndex];
      if (defaultTab?.isActive) {
        loadTabData(defaultTab);
      }
    }
  }, [selectedProjectId, selectedServiceTitle, tabConfigs.length, location.pathname]);

  useEffect(() => {
    if (selectedProjectId && tabConfigs.length > 0) {
      const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
      const currentTabConfig = tabConfigs[currentIndex];
      if (currentTabConfig?.isActive) {
        loadTabData(currentTabConfig);
      }
    }
  }, [activeTab, selectedProjectId]);

  // ✅ FIXED: Main useEffect with asset sell request handling (NO INFINITE LOOP)
  useEffect(() => {
    const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
    const currentTabConfig = tabConfigs[currentIndex];
    const currentTabType = currentTabConfig?.tabType;

    // ✅ FIXED: Changed 'loading' to 'pending' to match Redux Toolkit status
    let acceptRejectStatus: 'idle' | 'pending' | 'succeeded' | 'failed' = 'idle';
    let resetFunction: any = null;
    let statusError: string | null = null;
    let successMessage: string | null = null;

    if (currentTabType === 'unitsSubscription') {
      acceptRejectStatus = unitsAcceptRejectStatus;
      resetFunction = resetUnitsAcceptRejectStatus;
      statusError = error;
    } else if (currentTabType === 'assetPurchase') {
      acceptRejectStatus = assetAcceptRejectStatus;
      resetFunction = resetAssetAcceptRejectStatus;
      statusError = error;
    } else if (currentTabType === 'assetRevaluation') {
      acceptRejectStatus = revaluationAcceptRejectStatus;
      resetFunction = resetRevaluationAcceptRejectStatus;
      statusError = error;
    } else if (currentTabType === 'contributionRequest') {
      if (
        contributionAcceptRejectResponse?.results &&
        Array.isArray(contributionAcceptRejectResponse.results) &&
        contributionAcceptRejectResponse.results.length > 0
      ) {
        acceptRejectStatus = 'succeeded';
        successMessage = contributionAcceptRejectResponse.message;
      } else if (contributionAcceptRejectError) {
        acceptRejectStatus = 'failed';
      }
      resetFunction = clearAcceptRejectResponse;
      statusError = contributionAcceptRejectError;
    } else if (currentTabType === 'unitSell') {
      if (acceptRejectSellUnitsResponse?.success) {
        acceptRejectStatus = 'succeeded';
        successMessage = acceptRejectSellUnitsResponse.message;
      } else if (acceptRejectSellUnitsError) {
        acceptRejectStatus = 'failed';
      }
      resetFunction = clearAcceptRejectSellUnitsResponse;
      statusError = acceptRejectSellUnitsError;
    } else if (currentTabType === 'assetSellRequest') {
      // ✅ Handle asset sell request status
      if (acceptRejectSellAssetResponse?.success) {
        acceptRejectStatus = 'succeeded';
        successMessage = acceptRejectSellAssetResponse.message;
      } else if (sellAssetRequestsError) {
        acceptRejectStatus = 'failed';
      }
      resetFunction = clearAcceptRejectSellAssetResponse;
      statusError = sellAssetRequestsError;
    }

    // Handle success
    if (acceptRejectStatus === 'succeeded' && isAdmin) {
      const hasResults =
        contributionAcceptRejectResponse?.results &&
        Array.isArray(contributionAcceptRejectResponse.results) &&
        contributionAcceptRejectResponse.results.length > 0;

      const resultCount =
        hasResults && contributionAcceptRejectResponse.results
          ? contributionAcceptRejectResponse.results.length
          : 0;

      const isBatchOperation = batchConfirmDialogOpen || resultCount > 1;

      if (currentTabType === 'contributionRequest') {
        if (isBatchOperation) {
          if (hasResults && contributionAcceptRejectResponse.results) {
            const successCount = contributionAcceptRejectResponse.results.filter(
              (r) => r.success
            ).length;

            setSnackbar({
              open: true,
              message:
                contributionAcceptRejectResponse.message ||
                `Successfully processed ${successCount} out of ${resultCount} requests`,
              severity: successCount === resultCount ? 'success' : 'warning'
            });
          }

          setBatchConfirmDialogOpen(false);
        } else {
          const firstResult = contributionAcceptRejectResponse?.results?.[0];
          setSnackbar({
            open: true,
            message:
              firstResult?.message ||
              contributionAcceptRejectResponse?.message ||
              `Request ${actionType}ed successfully!`,
            severity: 'success'
          });

          setConfirmDialogOpen(false);
        }
      } else {
        // ✅ Handle unit sell, asset sell, and other request types
        setSnackbar({
          open: true,
          message: successMessage || `Request ${actionType}ed successfully!`,
          severity: 'success'
        });

        setConfirmDialogOpen(false);
      }

      if (resetFunction) {
        dispatch(resetFunction());
      }

      if (currentTabConfig?.isActive) {
        loadTabData(currentTabConfig);
        if (currentTabType === 'unitSell') {
          callRevisedLandingDataAPI(currentTabConfig.subscriptionType || '');
        }
      }
    } else if (acceptRejectStatus === 'failed' && statusError) {
      setSnackbar({
        open: true,
        message: statusError,
        severity: 'error'
      });
      setConfirmDialogOpen(false);
      setBatchConfirmDialogOpen(false);

      if (resetFunction) {
        dispatch(resetFunction());
      }

      if (currentTabType === 'unitSell' && currentTabConfig?.isActive) {
        loadTabData(currentTabConfig);
      }
    }
  }, [
    unitsAcceptRejectStatus,
    assetAcceptRejectStatus,
    revaluationAcceptRejectStatus,
    contributionAcceptRejectResponse,
    contributionAcceptRejectError,
    acceptRejectSellUnitsResponse,
    acceptRejectSellUnitsError,
    acceptRejectSellAssetResponse, // ✅ Added
    sellAssetRequestsError,
    error,
    actionType,
    dispatch,
    activeTab,
    isAdmin,
    tabConfigs.length,
    batchConfirmDialogOpen,
    selectedProjectId
  ]);

  // ✅ Load tab data with assetSellRequest handling
  const loadTabData = (tabConfig: TabConfig) => {
    const unitType = tabConfig?.subscriptionType;

    if (tabConfig.tabType === 'unitsSubscription') {
      const payload: GetPurchaseRequestsPayload = {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        unitType: unitType,
        pageSize: 100,
        continuationToken: null
      };

      if (!isAdmin && investorEmail) {
        payload.filters = { investorEmailId: investorEmail };
      }
      dispatch(getPurchaseUnitsRequests(payload) as any);
    } else if (tabConfig.tabType === 'assetPurchase') {
      const payload: GetAssetRequestsPayload = {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        unitType: unitType,
        pageSize: 100,
        continuationToken: null
      };
      dispatch(getPurchaseAssetRequests(payload) as any);
    } else if (tabConfig.tabType === 'assetRevaluation') {
      const payload: GetRevaluationRequestsPayload = {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        unitType: unitType,
        pageSize: 100,
        continuationToken: null
      };
      dispatch(getRevaluationAssetRequests(payload) as any);
    } else if (tabConfig.tabType === 'contributionRequest') {
      const payload: GetContributionRequestsPayload = {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        unitType: unitType as 'growthUnits' | 'incomeUnits',
        frequency: 'daily',
        pageSize: 100,
        continuationToken: null
      };
      dispatch(getContributionRequests(payload) as any);
    } else if (tabConfig.tabType === 'unitSell') {
      const payload: GetSellRequestsPayload = {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        unitType: unitType,
        pageSize: 100,
        continuationToken: null
      };
      dispatch(getSellUnitsRequests(payload) as any);
    } else if (tabConfig.tabType === 'assetSellRequest') {
      // ✅ Load asset sell requests from simulation slice
      const payload: GetSellAssetRequestsPayload = {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        unitType: unitType as 'incomeUnits' | 'growthUnits',
        pageSize: 100,
        currentPage: 1
      };
      dispatch(getSellAssetRequests(payload) as any);
    }
  };

  const callRevisedLandingDataAPI = async (unitType: string) => {
    try {
      const payload = {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        isAdmin: isAdmin
      };
      dispatch(getLandingData(payload) as any);
    } catch (error) {
      console.error('Landing data API error:', error);
    }
  };

  // Helper to show certificate modal
  const handleShowCertificate = (request: PurchaseRequest, unitType: string) => {
    setCertificatePayload({
      mode: 'api',
      payload: {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        unitType: unitType as 'incomeUnits' | 'growthUnits',
        investorEmail: request.investorEmailId
      }
    });
    setShowCertificateModal(true);
  };

  // ✅ FIXED: executeAction with proper asset sell request handling (NO INFINITE LOOP)
  const executeAction = async () => {
    if (!selectedRequest) return;

    const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
    const currentTabConfig = tabConfigs[currentIndex];
    const unitType = currentTabConfig?.subscriptionType;
    const requestId = getRequestId(selectedRequest);
    const action = actionType === 'accept' ? 'accepted' : 'rejected';

    // Handle contribution request
    if (currentTabConfig?.tabType === 'contributionRequest') {
      const contributionReq = selectedRequest as ContributionRequest;
      const payload: AcceptRejectRequestPayload = {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        unitType: unitType as 'incomeUnits' | 'growthUnits',
        requests: [
          {
            frequency: contributionReq.frequency || 'monthly',
            date: contributionReq.date || new Date().toISOString().split('T')[0],
            requestId,
            action: action as 'accepted' | 'rejected'
          }
        ]
      };

      dispatch(acceptRejectContributionRequest(payload) as any);
      callRevisedLandingDataAPI(unitType);
      return;
    }

    // ✅ FIXED: Handle asset sell request (let useEffect handle response)
    if (currentTabConfig?.tabType === 'assetSellRequest') {
      const assetSellReq = selectedRequest as SellAssetRequestItem;

      const payload: AcceptRejectSellAssetRequestPayload = {
        groupId: selectedProjectId!,
        serviceId: 'fundManagementInvestment',
        unitType: currentTabConfig.subscriptionType as 'incomeUnits' | 'growthUnits',
        assetSellId: assetSellReq.assetSellId,
        action,
        date_str: assetSellReq.requestDate || ''
      };

      dispatch(acceptRejectSellAssetRequest(payload));
      callRevisedLandingDataAPI(unitType);
      return;
    }

    // ✅ Handle unit sell request
    if (currentTabConfig?.tabType === 'unitSell') {
      const sellReq = selectedRequest as SellRequest;

      const payload: AcceptRejectSellUnitsPayload = {
        groupId: selectedProjectId!,
        serviceId: 'fundManagementInvestment',
        unitType: unitType as 'incomeUnits' | 'growthUnits',
        requestId: requestId,
        date_str: sellReq.requestDate || '',
        action: action as 'accepted' | 'rejected'
      };

      dispatch(acceptRejectSellUnitsRequest(payload) as any);
      return;
    }

    // Existing logic for other request types
    if (
      'investorName' in selectedRequest &&
      !('sellUnits' in selectedRequest) &&
      !('frequency' in selectedRequest)
    ) {
      const purchaseReq = selectedRequest as PurchaseRequest;
      const payload: AcceptRejectUnitsPayload = {
        groupId: selectedProjectId!,
        serviceId: 'fundManagementInvestment',
        unitType,
        requestId,
        date_str: purchaseReq?.date_str || '',
        fromMarketplace: purchaseReq?.fromMarketplace || false,
        action
      };

      const result = await dispatch(acceptRejectUnitsRequest(payload) as any);

      // ✅ Show certificate on accept for income/growth units only
      if (
        acceptRejectUnitsRequest.fulfilled.match(result) &&
        actionType === 'accept' &&
        (unitType === 'incomeUnits' || unitType === 'growthUnits')
      ) {
        handleShowCertificate(purchaseReq, unitType);
      }
    } else if ('asset' in selectedRequest && 'assetData' in selectedRequest.asset) {
      const payload: AcceptRejectRevaluationPayload = {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        unitType,
        requestId,
        action
      };
      dispatch(acceptRejectRevaluationRequest(payload) as any);
    } else if ('asset' in selectedRequest) {
      const payload: AcceptRejectAssetPayload = {
        groupId: selectedProjectId || '',
        serviceId: 'fundManagementInvestment',
        unitType,
        requestId,
        action
      };
      dispatch(acceptRejectAssetRequest(payload) as any);
    }

    callRevisedLandingDataAPI(unitType);
  };

  const executeBatchAction = async () => {
    const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
    const currentTabConfig = tabConfigs[currentIndex];
    const unitType = currentTabConfig?.subscriptionType;

    if (currentTabConfig?.tabType !== 'contributionRequest') {
      return;
    }

    const pendingContributionRequests = (contributionRequests || []).filter(
      (req) => req.status === 'pending'
    ) as ContributionRequest[];

    if (pendingContributionRequests.length === 0) {
      setSnackbar({
        open: true,
        message: 'No pending requests to process',
        severity: 'info'
      });
      setBatchConfirmDialogOpen(false);
      return;
    }

    const action = batchActionType === 'accept' ? 'accepted' : 'rejected';

    const payload: AcceptRejectRequestPayload = {
      groupId: selectedProjectId || '',
      serviceId: 'fundManagementInvestment',
      unitType: unitType as 'incomeUnits' | 'growthUnits',
      requests: pendingContributionRequests.map((req) => ({
        frequency: req.frequency || 'monthly',
        date: req.date || new Date().toISOString().split('T')[0],
        requestId: getRequestId(req),
        action: action as 'accepted' | 'rejected'
      }))
    };

    dispatch(acceptRejectContributionRequest(payload) as any);
    callRevisedLandingDataAPI(unitType);
  };

  const handleAction = (
    request:
      | PurchaseRequest
      | AssetRequest
      | RevaluationRequest
      | ContributionRequest
      | SellRequest
      | SellAssetRequestItem,
    action: 'accept' | 'reject'
  ) => {
    setSelectedRequest(request);
    setActionType(action);
    setConfirmDialogOpen(true);
  };

  const handleBatchAction = (action: 'accept' | 'reject') => {
    setBatchActionType(action);
    setBatchConfirmDialogOpen(true);
  };

  const handleViewRequest = (
    request:
      | PurchaseRequest
      | AssetRequest
      | RevaluationRequest
      | ContributionRequest
      | SellRequest
      | SellAssetRequestItem
  ) => {
    setSelectedRequest(request);
    setDialogOpen(true);
  };

  const isContributionRequest = (
    req:
      | PurchaseRequest
      | AssetRequest
      | RevaluationRequest
      | ContributionRequest
      | SellRequest
      | SellAssetRequestItem
  ): req is ContributionRequest => {
    return (
      'frequency' in req &&
      'contributionAmount' in req &&
      'investorEmailId' in req &&
      !('asset' in req)
    );
  };

  // ✅ Get current tab data including asset sell requests
  const getCurrentTabData = () => {
    const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
    const currentTabConfig = tabConfigs[currentIndex];

    if (!currentTabConfig) {
      return {
        all: [],
        pending: [],
        accepted: [],
        rejected: [],
        isActive: false
      };
    }

    let requests: any[] = [];

    if (currentTabConfig.tabType === 'unitsSubscription') {
      requests = purchaseRequests || [];
    } else if (currentTabConfig.tabType === 'assetPurchase') {
      requests = assetRequests || [];
    } else if (currentTabConfig.tabType === 'assetRevaluation') {
      requests = revaluationRequests || [];
    } else if (currentTabConfig.tabType === 'contributionRequest') {
      requests = contributionRequests || [];
    } else if (currentTabConfig.tabType === 'unitSell') {
      const unitType = currentTabConfig?.subscriptionType;
      requests = (sellRequests || []).filter((req) => req.unitType === unitType);
    } else if (currentTabConfig.tabType === 'assetSellRequest') {
      // ✅ Get asset sell requests
      const unitType = currentTabConfig?.subscriptionType;
      requests = (sellAssetRequestsData?.sellAssetRequests || []).filter(
        (req) => req.unitType === unitType
      );
    }

    const filteredData = filterRequests(requests, filterStatus, searchTerm) || [];

    return {
      all: filteredData,
      pending: filteredData.filter((r) => r.status === 'pending'),
      accepted: filteredData.filter((r) => r.status === 'accepted' || r.status === 'approved'),
      rejected: filteredData.filter((r) => r.status === 'rejected'),
      isActive: currentTabConfig.isActive || false
    };
  };

  const TabPanel = ({
    children,
    value,
    index
  }: {
    children: React.ReactNode;
    value: number;
    index: number;
  }) => (
    <div hidden={value !== index} {...(value === index && { id: `tabpanel-${index}` })}>
      {value === index && <Box>{children}</Box>}
    </div>
  );

  if (tabConfigs.length === 0) {
    return (
      <Container maxWidth="xl" sx={{ padding: 3, textAlign: 'center' }}>
        <Alert severity="info">No transaction types are available for your role.</Alert>
      </Container>
    );
  }

  const currentTabData = getCurrentTabData();
  const currentIndex = activeTab < tabConfigs.length ? activeTab : 0;
  const currentTabConfig = tabConfigs[currentIndex];

  // ✅ FIXED: Include all loading states
  const isActionLoading =
    loading ||
    sellAssetRequestsLoading ||
    acceptRejectSellAssetLoading || // ✅ Added
    (currentTabConfig?.tabType === 'contributionRequest' && contributionAcceptRejectLoading) ||
    (currentTabConfig?.tabType === 'unitSell' && acceptRejectSellUnitsLoading);

  const isContributionTab = currentTabConfig?.tabType === 'contributionRequest';
  const hasPendingContributions = currentTabData?.pending.length > 0;

  return (
    <Container maxWidth="xl" sx={{ padding: { xs: 1, sm: 2, md: 3 }, minHeight: '100vh' }}>
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: { xs: 2, md: 3 },
          flexWrap: 'wrap',
          gap: { xs: 1, md: 0 }
        }}
      >
        <Box
          sx={{
            width: { xs: 32, md: 40 },
            height: { xs: 32, md: 40 },
            borderRadius: 2,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: { xs: 1.5, md: 2 }
          }}
        >
          <FaDollarSign size={isMobile ? 16 : 20} color="white" />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="h6"
            component="h1"
            sx={{ fontWeight: 500, color: '#333', fontSize: { xs: '1rem', md: '1.2rem' } }}
          >
            {isAdmin ? 'Fund Management Approvals' : 'Fund Management Requests'}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: '#666', marginTop: 0.5, fontSize: { xs: '0.75rem', md: '0.8rem' } }}
          >
            {isAdmin
              ? 'Review and manage fund transactions and requests'
              : 'View your fund transaction requests'}
          </Typography>
        </Box>
      </Box>

      {/* Search and Filter */}
      <Paper
        sx={{
          padding: { xs: 1.5, md: 2 },
          borderRadius: 3,
          marginBottom: { xs: 2, md: 3 },
          backgroundColor: '#f8f9fa'
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={isContributionTab && isAdmin ? 4 : 8}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search by name, email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: <FaSearch color="#999" style={{ marginRight: 8 }} size={14} />
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  backgroundColor: 'white'
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={isContributionTab && isAdmin ? 3 : 4}>
            <FormControl fullWidth size="small">
              <InputLabel>Status Filter</InputLabel>
              <Select
                value={filterStatus}
                label="Status Filter"
                onChange={(e) => setFilterStatus(e.target.value)}
                sx={{ borderRadius: 2, backgroundColor: 'white' }}
              >
                <MenuItem value="all">All Status</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="accepted">Accepted</MenuItem>
                <MenuItem value="approved">Approved</MenuItem>
                <MenuItem value="rejected">Rejected</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {isContributionTab && isAdmin && (
            <Grid item xs={12} md={5}>
              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                <Tooltip
                  title={
                    hasPendingContributions
                      ? `Accept all ${currentTabData?.pending.length} pending requests`
                      : 'No pending requests'
                  }
                  arrow
                >
                  <span>
                    <Badge
                      badgeContent={currentTabData?.pending.length}
                      color="primary"
                      max={99}
                      sx={{
                        '& .MuiBadge-badge': {
                          backgroundColor: hasPendingContributions ? '#4caf50' : '#bdbdbd'
                        }
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<FaCheckDouble size={14} />}
                        onClick={() => handleBatchAction('accept')}
                        disabled={!hasPendingContributions || contributionAcceptRejectLoading}
                        sx={{
                          backgroundColor: '#4caf50',
                          '&:hover': { backgroundColor: '#45a049' },
                          textTransform: 'none',
                          fontSize: '0.75rem',
                          borderRadius: 2
                        }}
                      >
                        Accept All
                      </Button>
                    </Badge>
                  </span>
                </Tooltip>
                <Tooltip
                  title={
                    hasPendingContributions
                      ? `Reject all ${currentTabData?.pending.length} pending requests`
                      : 'No pending requests'
                  }
                  arrow
                >
                  <span>
                    <Badge badgeContent={currentTabData?.pending.length} color="error" max={99}>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<FaTimesCircle size={14} />}
                        onClick={() => handleBatchAction('reject')}
                        disabled={!hasPendingContributions || contributionAcceptRejectLoading}
                        sx={{
                          color: '#f44336',
                          borderColor: '#f44336',
                          '&:hover': { backgroundColor: '#ffebee', borderColor: '#f44336' },
                          textTransform: 'none',
                          fontSize: '0.75rem',
                          borderRadius: 2
                        }}
                      >
                        Reject All
                      </Button>
                    </Badge>
                  </span>
                </Tooltip>
              </Box>
            </Grid>
          )}
        </Grid>
      </Paper>

      {/* ✅ FIXED: Error display including all error states */}
      {(error ||
        contributionAcceptRejectError ||
        sellAssetRequestsError ||
        acceptRejectSellUnitsError) && (
        <Alert
          severity="error"
          sx={{ marginBottom: 2 }}
          onClose={() => {
            dispatch(clearError());
            dispatch(clearAcceptRejectResponse());
            dispatch(clearAcceptRejectSellUnitsResponse());
          }}
        >
          {error ||
            contributionAcceptRejectError ||
            sellAssetRequestsError ||
            acceptRejectSellUnitsError}
        </Alert>
      )}

      <Paper sx={{ borderRadius: 3, overflow: 'hidden' }}>
        <Box sx={{ backgroundColor: 'white', borderBottom: '1px solid #e0e0e0' }}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => {
              if (newValue >= 0 && newValue < tabConfigs.length) {
                setActiveTab(newValue);
              }
            }}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 56,
              '& .MuiTab-root': {
                color: '#666',
                fontWeight: 400,
                fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem' },
                textTransform: 'none',
                minWidth: { xs: 90, sm: 110, md: 140 },
                maxWidth: 'none',
                padding: { xs: '8px 10px', sm: '10px 12px', md: '12px 16px' },
                whiteSpace: 'nowrap',
                flexShrink: 0,
                transition: 'all 0.2s ease',
                '&:hover': {
                  color: '#1976d2',
                  backgroundColor: 'rgba(25, 118, 210, 0.04)'
                }
              },
              '& .Mui-selected': {
                color: '#1976d2',
                fontWeight: 600
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#1976d2',
                height: 3,
                borderRadius: '3px 3px 0 0'
              }
            }}
          >
            {tabConfigs?.map((tab) => (
              <Tab
                key={tab?.key}
                label={
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      minWidth: 'fit-content',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {tab?.icon}
                    <span>{tab?.label}</span>
                    {!tab?.isActive && (
                      <Button
                        size="small"
                        sx={{
                          height: 16,
                          fontSize: '0.5rem',
                          backgroundColor: '#e0e0e0',
                          color: '#666',
                          marginLeft: 0.5,
                          textTransform: 'none',
                          minWidth: 'unset',
                          padding: '0 4px'
                        }}
                      >
                        Soon
                      </Button>
                    )}
                  </Box>
                }
              />
            ))}
          </Tabs>
        </Box>

        <Box sx={{ padding: { xs: 1, md: 2 } }}>
          {tabConfigs?.map((tabConfig, tabIndex) => (
            <TabPanel key={tabConfig.key} value={activeTab} index={tabIndex}>
              {tabConfig?.isActive ? (
                isActionLoading ? (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    <CircularProgress />
                    <Typography variant="body2" sx={{ mt: 2, fontSize: '0.8rem' }}>
                      Loading {tabConfig?.label?.toLowerCase()}...
                    </Typography>
                  </Box>
                ) : (
                  <Grid container spacing={2}>
                    {currentTabData?.all.length > 0 ? (
                      currentTabData?.all.map((request) => (
                        <Grid item xs={12} sm={6} lg={4} key={getRequestId(request)}>
                          <RequestCard
                            request={request}
                            tabConfig={currentTabConfig}
                            onViewRequest={handleViewRequest}
                            onAction={handleAction}
                            loading={isActionLoading}
                          />
                        </Grid>
                      ))
                    ) : (
                      <Grid item xs={12}>
                        <Box sx={{ textAlign: 'center', py: 4 }}>
                          <Typography variant="body1" sx={{ color: '#666', fontSize: '0.9rem' }}>
                            No {tabConfig.label.toLowerCase()} requests found
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ color: '#999', fontSize: '0.75rem', mt: 1 }}
                          >
                            {tabConfig.description}
                          </Typography>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                )
              ) : (
                <Box sx={{ textAlign: 'center', py: 8 }}>
                  <Box sx={{ marginBottom: 3, opacity: 0.5 }}>{tabConfig.icon}</Box>
                  <Typography
                    variant="h6"
                    sx={{ marginBottom: 1, fontSize: '1rem', fontWeight: 500 }}
                  >
                    {tabConfig.label}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: '#666', fontSize: '0.8rem', marginBottom: 2 }}
                  >
                    {tabConfig.description}
                  </Typography>
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 1,
                      padding: '8px 16px',
                      backgroundColor: '#f0f0f0',
                      borderRadius: 2
                    }}
                  >
                    <FaClock size={14} color="#666" />
                    <Typography variant="body2" sx={{ color: '#666', fontSize: '0.75rem' }}>
                      Coming Soon - API Integration in Progress
                    </Typography>
                  </Box>
                </Box>
              )}
            </TabPanel>
          ))}
        </Box>
      </Paper>

      {/* Request Details Dialog */}
      <RequestDialog
        open={dialogOpen}
        request={selectedRequest as any}
        onClose={() => setDialogOpen(false)}
      />

      {/* Single Request Confirmation Dialog */}
      {isAdmin && (
        <Dialog
          open={confirmDialogOpen}
          onClose={() => setConfirmDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: actionType === 'accept' ? '#e8f5e8' : '#ffebee',
              color: actionType === 'accept' ? '#2e7d32' : '#c62828'
            }}
          >
            <FaExclamationTriangle style={{ marginRight: 8 }} />
            <Typography variant="h6" sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
              Confirm {actionType === 'accept' ? 'Accept' : 'Reject'} Request
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ padding: 3 }}>
            {selectedRequest && (
              <Box>
                <Alert
                  severity={actionType === 'accept' ? 'success' : 'warning'}
                  sx={{ marginBottom: 2, fontSize: '0.75rem' }}
                >
                  You are about to <strong>{actionType}</strong> this request.
                  {(() => {
                    if (isSellAssetRequest(selectedRequest)) {
                      return ` Asset: ${selectedRequest.assetId}, Amount: ${formatCurrency(
                        parseFloat(selectedRequest.finalPrice)
                      )}`;
                    } else if ('investedAmount' in selectedRequest) {
                      return ` Amount: ${formatCurrency(selectedRequest.investedAmount)}`;
                    } else if ('sellUnits' in selectedRequest) {
                      const amount =
                        parseFloat(selectedRequest.sellUnits) *
                        parseFloat(selectedRequest.unitPrice);
                      return ` Amount: ${formatCurrency(amount)}`;
                    } else if (isContributionRequest(selectedRequest)) {
                      return ` Amount: ${formatCurrency(selectedRequest.contributionAmount || 0)}`;
                    }
                    return '';
                  })()}
                </Alert>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ padding: 2 }}>
            <Button
              onClick={() => setConfirmDialogOpen(false)}
              disabled={isActionLoading}
              sx={{ textTransform: 'none', fontSize: '0.75rem' }}
            >
              Cancel
            </Button>
            <Button
              onClick={executeAction}
              variant="contained"
              disabled={isActionLoading}
              startIcon={isActionLoading ? <CircularProgress size={16} /> : null}
              sx={{
                backgroundColor: actionType === 'accept' ? '#4caf50' : '#f44336',
                textTransform: 'none',
                fontSize: '0.75rem',
                fontWeight: 500
              }}
            >
              {isActionLoading
                ? 'Processing...'
                : `Confirm ${actionType === 'accept' ? 'Accept' : 'Reject'}`}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Batch Confirmation Dialog */}
      {isAdmin && (
        <Dialog
          open={batchConfirmDialogOpen}
          onClose={() => setBatchConfirmDialogOpen(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: batchActionType === 'accept' ? '#e8f5e8' : '#ffebee',
              color: batchActionType === 'accept' ? '#2e7d32' : '#c62828'
            }}
          >
            <FaExclamationTriangle style={{ marginRight: 8 }} />
            <Typography variant="h6" sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
              Confirm {batchActionType === 'accept' ? 'Accept' : 'Reject'} All Pending Requests
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ padding: 3 }}>
            <Alert
              severity={batchActionType === 'accept' ? 'success' : 'warning'}
              sx={{ marginBottom: 2, fontSize: '0.75rem' }}
            >
              You are about to <strong>{batchActionType}</strong> all{' '}
              <strong>{currentTabData?.pending.length}</strong> pending contribution requests.
              <br />
              <br />
              This action cannot be undone. Are you sure you want to continue?
            </Alert>
          </DialogContent>
          <DialogActions sx={{ padding: 2 }}>
            <Button
              onClick={() => setBatchConfirmDialogOpen(false)}
              disabled={contributionAcceptRejectLoading}
              sx={{ textTransform: 'none', fontSize: '0.75rem' }}
            >
              Cancel
            </Button>
            <Button
              onClick={executeBatchAction}
              variant="contained"
              disabled={contributionAcceptRejectLoading}
              startIcon={
                contributionAcceptRejectLoading ? (
                  <CircularProgress size={16} />
                ) : batchActionType === 'accept' ? (
                  <FaCheckDouble size={14} />
                ) : (
                  <FaTimesCircle size={14} />
                )
              }
              sx={{
                backgroundColor: batchActionType === 'accept' ? '#4caf50' : '#f44336',
                textTransform: 'none',
                fontSize: '0.75rem',
                fontWeight: 500
              }}
            >
              {contributionAcceptRejectLoading
                ? 'Processing...'
                : `Confirm ${batchActionType === 'accept' ? 'Accept' : 'Reject'} All`}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Certificate Modal */}
      {/* {showCertificateModal && certificatePayload && (
        <CertificateViewer
          mode={certificatePayload.mode}
          payload={certificatePayload.payload}
          onClose={() => {
            setShowCertificateModal(false);
            setCertificatePayload(null);
            dispatch(clearCurrentBuySellCertificateData());
          }}
        />
      )} */}

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: '100%', borderRadius: 2, fontSize: '0.75rem' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ApprovalRequest;
